// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  managements: {
    schedules: path(ROOTS_DASHBOARD, 'managements/schedules'),
    patients: path(ROOTS_DASHBOARD, 'managements/patients'),

    bookings: path(ROOTS_DASHBOARD, 'managements/bookings/list'),
    bookingForm: path(ROOTS_DASHBOARD, 'managements/bookings/form'),

    banners: path(ROOTS_DASHBOARD, 'managements/banners/list'),
    bannersForm: path(ROOTS_DASHBOARD, 'managements/banners/form'),

    doctors: path(ROOTS_DASHBOARD, 'managements/doctors/list'),
    doctorsForm: path(ROOTS_DASHBOARD, 'managements/doctors/form'),

    payments: path(ROOTS_DASHBOARD, 'managements/payments/list'),
    paymentsForm: path(ROOTS_DASHBOARD, 'managements/payments/form'),

    faqs: path(ROOTS_DASHBOARD, 'managements/faqs/list'),
    faqsForm: path(ROOTS_DASHBOARD, 'managements/faqs/form'),

    accountant: path(ROOTS_DASHBOARD, 'managements/accountant'),
    accountantForm: path(ROOTS_DASHBOARD, 'managements/accountant/form'),

    scheduleForm: path(ROOTS_DASHBOARD, 'managements/schedule/form'),

    report: path(ROOTS_DASHBOARD, 'managements/report'),
    reportForm: path(ROOTS_DASHBOARD, 'managements/report/form'),

    services: path(ROOTS_DASHBOARD, 'managements/services/list'),
    serviceForm: path(ROOTS_DASHBOARD, 'managements/services/form'),

    servicesObject: path(ROOTS_DASHBOARD, 'managements/service-patient-objects'),
    serviceObjectForm: path(ROOTS_DASHBOARD, 'managements/service-patient-objects/form'),

    subjects: path(ROOTS_DASHBOARD, 'managements/subjects/list'),
    subjectForm: path(ROOTS_DASHBOARD, 'managements/subjects/form'),

    postitonBanners: path(ROOTS_DASHBOARD, 'managements/banners/position'),
    postitonBannersForm: path(ROOTS_DASHBOARD, 'managements/banners/position/form'),

    galleries: path(ROOTS_DASHBOARD, 'managements/galleries'),

    news: path(ROOTS_DASHBOARD, 'managements/news'),

    categories: path(ROOTS_DASHBOARD, 'managements/cms/categories/list'),
    categoryForm: path(ROOTS_DASHBOARD, 'managements/cms/categories/form'),

    articles: path(ROOTS_DASHBOARD, 'managements/cms/articles/list'),
    articlesForm: path(ROOTS_DASHBOARD, 'managements/cms/articles/form'),

    cms: path(ROOTS_DASHBOARD, 'managements/cms'),
    auth: path(ROOTS_DASHBOARD, 'managements/auth'),

    users: path(ROOTS_DASHBOARD, 'managements/auth/users/list'),
    usersForm: path(ROOTS_DASHBOARD, 'managements/auth/users/form'),

    roles: path(ROOTS_DASHBOARD, 'managements/auth/roles/list'),
    rolesForm: path(ROOTS_DASHBOARD, 'managements/auth/roles/form'),

    guides: path(ROOTS_DASHBOARD, 'managements/cms/guides/list'),
    guidesForm: path(ROOTS_DASHBOARD, 'managements/cms/guides/form'),

    packages: path(ROOTS_DASHBOARD, 'managements/cms/packages/list'),
    packagesForm: path(ROOTS_DASHBOARD, 'managements/cms/packages/form'),

    contents: path(ROOTS_DASHBOARD, 'managements/cms/contents/list'),
    contentsForm: path(ROOTS_DASHBOARD, 'managements/cms/contents/form'),

    cmsBanners: path(ROOTS_DASHBOARD, 'managements/cms/banners/list'),
    cmsBannersForm: path(ROOTS_DASHBOARD, 'managements/cms/banners/form'),
  },
};

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};

export const PATH_ZONE_ON_STORE = 'https://mui.com/store/items/zone-landing-page/';

export const PATH_MINIMAL_ON_STORE = 'https://mui.com/store/items/minimal-dashboard/';

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/rWMDOkMZYw2VpTdNuBBCvN/%5BPreview%5D-Minimal-Web.26.11.22?node-id=0%3A1&t=ya2mDFiuhTXXLLF1-1';
